import { useQuery } from '@tanstack/react-query'

import { getPincodeSuggestions, getRecentPincodes } from './functions'

function usePincodeSuggestions(pincodeInput: string) {
  return useQuery(
    ['userPincodeSuggestions', pincodeInput],
    () => getPincodeSuggestions(pincodeInput),
    {
      staleTime: 0,
      enabled: false,
    }
  )
}

function useRecentPincodes() {
  return useQuery(['userRecentPincodes'], getRecentPincodes, {
    staleTime: 0,
    enabled: false,
  })
}

export { useRecentPincodes, usePincodeSuggestions }
